import Vue from "vue";
import VueRouter from "vue-router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import routes from "./routes";
import DataStore from "@/global/storages/index";
import userService from "@/global/services/user";
import Store from "@/store/index";

Vue.use(VueRouter);

const appRouter = new VueRouter({
  mode: "history",
  routes
});

appRouter.firstInit = false;

// eslint-disable-next-line
appRouter.beforeEach(async (to, from, next) => {
  NProgress.start();
  const TOKEN = DataStore.getToken();
  const {
    $options: {
      store: { dispatch }
    }
  } = appRouter.app;
  if (!TOKEN) {
    let referer = window.location.href;
    window.location.href =
      "https://account" + process.env.VUE_APP_DOMAIN + "/?referer=" + referer;
    return;
  }
  if (!appRouter.firstInit) {
    appRouter.firstInit = true;
    const userInfo = await userService.info();
    Store.commit("getUserAvatar", userInfo.avatar.path);
    Store.commit("getUserName", userInfo.nickname || userInfo.name);

    // 初始化主题色
    const theme = localStorage.getItem("theme") || "dark";
    dispatch("setTheme", theme);
  }
  next();
});

// eslint-disable-next-line
appRouter.afterEach((to, from) => {
  // eslint-disable-next-line
  typeof gio === "function" && gio("send");
  // eslint-disable-next-line
  window.collectEvent('predefinePageView')

  NProgress.done();
});

export default appRouter;
